export const NAT_CONFIG_SECTION_EVENT =
	'canvas-agent:nat-config:section';
export const NAT_CONFIG_CREATE_MODAL_EVENT =
	'canvas-agent:nat-config:create-modal';
export const NAT_CONFIG_FILTER_EVENT =
	'canvas-agent:nat-config:filter';
export const NAT_CONFIG_FOCUS_EVENT =
	'canvas-agent:nat-config:focus';
export const NAT_CONFIG_EDIT_MODAL_EVENT =
	'canvas-agent:nat-config:edit-modal';
export const NAT_CONFIG_DELETE_MODAL_EVENT =
	'canvas-agent:nat-config:delete-modal';
